import { Component, computed, input } from '@angular/core';

interface Options {
  height?: number;
  width?: number;
} 

export interface FormImage {
  url: string;
  alt: string;
  options?: Options;
}

@Component({
  selector: 'app-form-image',
  imports: [],
  templateUrl: './form-image.component.html',
  styles: ``,
})
export class FormImageComponent {

  readonly formImage = input.required<FormImage>();

  viewState = computed(() => ({

    url: this.formImage().url,
    alt: this.formImage().alt,

    h: `${this.formImage().options?.height ?? 80}px`,
    w: `${this.formImage().options?.width ?? 260}px`

  }));

}
